import { render, staticRenderFns } from "./ColorDot.vue?vue&type=template&id=836f40a4"
import script from "./ColorDot.vue?vue&type=script&lang=js"
export * from "./ColorDot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports